var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShape9 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 50,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#shape-9_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F8F3F4",
  d: "M19.142 0 0 49.58h80L68.25 18.811 47.13 33.831z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "shape-9_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h80v49.58H0z"
})))));
export { SvgShape9 as ReactComponent };
export default __webpack_public_path__ + "static/media/shape-9.a17b7579b261276d0fbe.svg";